import PropTypes from 'prop-types';

import SideMsg from '#/modules/commonComponents/SideMsg';
import SnProductMappingCommandBar from
  '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingCommandBar';
import {
  snProductMappingSideMsgDetailBlock,
  snProductMappingSideMsgStatusBlock,
} from '#/modules/crmMgmt/aftersales/snProductMapping/data/snProductMappingSideMsgConfig';
import {
  canActivateSnProductMapping,
  canDeactivateSnProductMapping,
  canDeleteSnProductMapping,
} from '#/modules/crmMgmt/aftersales/snProductMapping/helper/snProductMappingStatus';

function hasSideActions(row) {
  return canActivateSnProductMapping(row)
    || canDeactivateSnProductMapping(row?.status)
    || canDeleteSnProductMapping(row?.status);
}

const SnProductMappingSideMsg = ({ displayData, onRefetch, onDeleted }) => {
  const blocks = [
    snProductMappingSideMsgStatusBlock,
    {
      condition: hasSideActions,
      fields: [
        {
          key: 'actions',
          label: '操作',
          render: (row) => (
            <div className="side_msg-row">
              <h3>操作</h3>
              <SnProductMappingCommandBar
                detail={row}
                onRefetch={onRefetch}
                onDeleted={onDeleted}
                showEdit={false}
              />
            </div>
          ),
        },
      ],
    },
    snProductMappingSideMsgDetailBlock,
  ];

  return (
    <SideMsg
      title="物料序號"
      titleValue="productCode"
      displayData={displayData}
      blocks={blocks}
    />
  );
};

SnProductMappingSideMsg.propTypes = {
  displayData: PropTypes.object,
  onRefetch: PropTypes.func,
  onDeleted: PropTypes.func,
};

export default SnProductMappingSideMsg;
